import { HTTP } from '../helpers/http-common.js'
import authHeader from '../helpers/auth-header'
import helpers from '../helpers/helpers'


const  clientsService = {
  getDashboard
};

export default clientsService

function getDashboard(codigo_sucursal = null) {
  let params = '';
  if (codigo_sucursal) {
    params = `?codigo_sucursal=${codigo_sucursal}`;
  }
  return HTTP.get(`dashboard${params}`,{
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}
